import MuiButton from '@mui/material/Button';
import styled from '@mui/material/styles/styled';

import { PRIMARY_COLORS, PRIMARY_SILVER_COLOR, SECONDARY_COLORS } from '../../../../themes/light';

export const MuiButtonConfig = {
  defaultProps: { disableElevation: true },
  styleOverrides: {
    root: {
      padding: '8px 16px',
      minWidth: 112,
      borderRadius: 0,
      '&.Mui-disabled': {
        color: PRIMARY_SILVER_COLOR[600],
        backgroundColor: PRIMARY_SILVER_COLOR[100],
        border: `1px solid ${PRIMARY_SILVER_COLOR[300]}`,
      },
      '& .MuiButton-endIcon .MuiSvgIcon-root': { width: 24, height: 24 },
    },
    outlined: {
      color: SECONDARY_COLORS.DARK_GREY,
      borderColor: PRIMARY_COLORS.PRIMARY_GREEN,
      fontWeight: 500,
    },
    contained: {
      '&:hover': { backgroundColor: PRIMARY_COLORS.PRIMARY_NEUTRAL_TEAL_HOVER },
    },
    sizeMedium: { height: 40, fontSize: 16 },
  },
};

export const MuiIconButtonConfig = {
  styleOverrides: { root: { '&.Mui-disabled': { opacity: '0.5' } } },
};

export const StyledButton = styled(MuiButton)(() => ({
  padding: '8px 16px',
  minWidth: 112,
  borderRadius: 0,
  '&.Mui-disabled': {
    color: PRIMARY_SILVER_COLOR[600],
    backgroundColor: PRIMARY_SILVER_COLOR[100],
    border: `1px solid ${PRIMARY_SILVER_COLOR[300]}`,
  },
  '& .MuiButton-endIcon .MuiSvgIcon-root': {
    width: 24,
    height: 24,
  },
  '&.MuiButton-outlined': {
    color: PRIMARY_COLORS.PRIMARY_MEDIUM_GREEN,
    borderColor: PRIMARY_COLORS.PRIMARY_MEDIUM_GREEN,
    fontWeight: 500,
  },
  '&.MuiButton-contained': {
    backgroundColor: PRIMARY_COLORS.PRIMARY_MEDIUM_GREEN,
  },
  '&.MuiButton-contained:hover': {
    backgroundColor: PRIMARY_COLORS.PRIMARY_MEDIUM_GREEN,
  },
  '&.MuiButton-sizeMedium': {
    height: 40,
    fontSize: 16,
  },
}));
